var map = {
	"./goldcoin/okwallet-logo.png": 64140,
	"./memetown/okwallet-logo.png": 33211,
	"./reflection/okwallet-logo.png": 17522,
	"./tapcoin/okwallet-logo.png": 36863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88759;